<template>
  <div
    class="rs-clear"
    @click="$emit('click')"
  >
    <RsIcon
      weight="far"
      icon="times-circle"
    />
    <span>{{ $ts('actions.clearFilterSet') }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsClear',

  emits: ['click'],
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
.rs-clear{
  display: inline-flex;
  align-items: center;
  color: $error;
  font-size: 0.875rem;
  cursor: pointer;
  transition: color 0.2s ease;
  .rs-icon{
    margin-right: 0.25rem;
  }
  &:hover{
   color: darken($error, 20%);
  }
}
</style>
